import { createTheme } from '@mui/material/styles';
import { colors } from 'styles/colors';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
  }
  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

export const theme = createTheme({
  palette: {
    primary: { main: '#073B70' },
    secondary: { main: '#7B88A8' },
    error: { main: '#F7403C' },
    success: { main: '#00a341' },
    warning: { main: '#FFA500' },
    neutral: { main: '#142C52' },
  },

  components: {
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          color: '#ffffff',
        },
        filledWarning: {
          color: colors.white,
        }
      },
    },
  },
});
